<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item> <i class="el-icon-lx-cascades"></i> 分配角色 </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="container">
      <el-form :inline="true" label-width="120px">
        <el-form-item label="用户名称:">
          <span>{{ realName }}</span>
        </el-form-item>
      </el-form>
    </div>
    <div class="container">
      <!--            <el-transfer-->
      <!--                    v-if="refreshTree"-->
      <!--                    ref="transfer"-->
      <!--                    filterable-->
      <!--                    v-model="rightData"-->
      <!--                    :data="leftData"-->
      <!--                    :props="defaultProps"-->
      <!--                    :button-texts="['删除', '添加']"-->
      <!--                    :titles="['可分配角色', '已分配角色']"-->
      <!--                    @change="handleChange"-->
      <!--            ></el-transfer>-->
      <tree-transfer
        :title="['可分配角色', '已分配角色']"
        :button_text="['添加', '取消']"
        :from_data="leftData"
        :to_data="rightData"
        :defaultProps="defaultProps"
        @add-btn="add"
        @remove-btn="remove"
        filter
        height="400px"
        :mode="mode"
        :node_key="nodeKey"
        :pid="parentId"
        v-if="refreshTree"
        ref="treeTransfer"
        :default-checked-keys="defaultCheckedKeys"
      ></tree-transfer>
    </div>
  </div>
</template>

<script>
import Api from "../../api/authority/index";
import TreeTransfer from "el-tree-transfer";
export default {
  name: "assignRole",
  components: {
    TreeTransfer,
  },
  props: {},
  data() {
    return {
      rightData: [],
      leftData: [],
      realName: this.$route.query.realName,
      defaultProps: {
        label: "roleName",
        key: "roleId",
      },
      refreshTree: true,
      parentId: "parentId",
      nodeKey: "roleId",
      mode: "transfer",
      defaultCheckedKeys: [],
    };
  },
  computed: {},
  created() {
    this.getUserRole();
    this.getUserAllRoles();
  },
  methods: {
    async getUserAllRoles() {
      let params = {
        memberId: this.$route.query.memberId,
      };
      let res = await Api.queryUserAllRoles(params);

      if (res.code == "200") {
        this.leftData = res.data;
        this.formatLeftData(this.leftData);
      }
    },
    async getUserRole() {
      let params = {
        memberId: this.$route.query.memberId,
      };
      let res = await Api.queryUserRole(params);

      if (res.code == "200" && res.data.length > 0) {
        this.rightData = res.data;
        // this.getDefaultCheckKeys(this.rightData)
      }
    },
    add(fromData, toData) {
      let roleIdList = [];
      toData.map((item) => {
        roleIdList.push(item.roleId);
      });

      let params = {
        memberId: this.$route.query.memberId,
        roleIdList: roleIdList,
      };

      Api.insertRole(params).then((res) => {
        if (res.code == "200") {
          this.$message({
            type: "success",
            message: "添加角色成功",
          });
          setTimeout(() => {
            //查询树的数据
            this.getUserRole();
            this.getUserAllRoles();
            //<el-tree>组件使用v-if重新加载
            this.refreshTree = false;
            this.$refs.treeTransfer.$nextTick(() => {
              this.refreshTree = true;
            });
          }, 100);
        }
      });
    },
    remove(fromData, toData) {
      let roleIdList = [];
      toData.map((item) => {
        roleIdList.push(item.roleId);
      });

      let params = {
        memberId: this.$route.query.memberId,
        roleIdList: roleIdList,
      };

      Api.insertRole(params).then((res) => {
        if (res.code == "200") {
          this.$message({
            type: "success",
            message: "删除角色成功",
          });
          setTimeout(() => {
            //查询树的数据
            this.getUserRole();
            this.getUserAllRoles();
            //<el-tree>组件使用v-if重新加载
            this.refreshTree = false;
            this.$refs.treeTransfer.$nextTick(() => {
              this.refreshTree = true;
            });
          }, 100);
        }
      });
    },
    getDefaultCheckKeys(data) {
      if (data.length) {
        for (let i = 0; i < data.length; i++) {
          this.defaultCheckedKeys.push(data[i].categoryId);
          if (data[i].children && data[i].children.length) {
            this.getDefaultCheckKeys(data[i].children);
          }
        }
      }
    },
    formatLeftData(data) {
      if (data.length) {
        for (let i = 0; i < data.length; i++) {
          if (data[i].flag == "have") this.$set(data[i], "disabled", true);
          else this.$set(data[i], "disabled", false);
          if (data[i].children && data[i].children.length) {
            this.formatLeftData(data[i].children);
          }
        }
      }
    },
  },
};
</script>

<style scoped></style>
